var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Watch, Utils, PropertyConverters, CustomTypedEvent, PropertyChangeEvent, CustomElementUtils, Debounce, PropertyChangeEventName, PacemEventTarget } from '@pacem/pacem-core';
import { LatLng, LatLngBounds } from './types';
// namespace Pacem.Components.Maps {
export var MapType;
(function (MapType) {
    MapType["ROAD"] = "road";
    MapType["SATELLITE"] = "satellite";
    MapType["HYBRID"] = "hybrid";
    MapType["TERRAIN"] = "terrain";
    MapType["HIGH_CONTRAST"] = "high_contrast";
})(MapType || (MapType = {}));
export var MapColorScheme;
(function (MapColorScheme) {
    MapColorScheme["LIGHT"] = "light";
    MapColorScheme["DARK"] = "dark";
    MapColorScheme["SYSTEM"] = "system";
})(MapColorScheme || (MapColorScheme = {}));
const MapConstsInternal = {
    MAP_SELECTOR: P + '-map',
    LINK_SELECTOR: P + '-map-link',
    MARKER_SELECTOR: P + '-map-marker',
    POLYLINE_SELECTOR: P + '-map-polyline',
    CIRCLE_SELECTOR: P + '-map-circle',
    POLYGON_SELECTOR: P + '-map-polygon',
    RECTANGLE_SELECTOR: P + '-map-rectangle',
    LAYER_SELECTOR: P + '-map-layer',
    OVERLAY_IMAGE_SELECTOR: P + '-map-overlay-image',
    OVERLAY_PANEL_SELECTOR: P + '-map-overlay-panel',
    GEOCODER_SELECTOR: P + '-map-geocode',
    DEFAULT_COORDS: { lat: 44.714188025077984, lng: 10.296516444873811 }
};
export const MapConsts = {
    DEFAULT_COORDS: MapConstsInternal.DEFAULT_COORDS
};
/** @deprecated */
export function isLatLng(obj) {
    return LatLng.isLatLng(obj);
}
/** @deprecated */
export function isLatLngBounds(obj) {
    return LatLngBounds.isLatLngBounds(obj);
}
const DEFAULT_MAPTARGET_KEY = 'defaultMapTarget';
export const LatLngConverter = {
    convert: attr => {
        const arr = /^\s*([+\-\d\.]+)\s*,?\s*([+\-\d\.]+)\s*$/.exec(attr);
        if (arr && arr.length > 2) {
            return { lat: parseFloat(arr[1]), lng: parseFloat(arr[2]) };
        }
        return JSON.parse(attr);
    },
    convertBack: prop => JSON.stringify(prop)
};
export const LatLngBoundsConverter = {
    convert: attr => {
        const arr = /^\s*([+\-\d\.]+)\s*,?\s*([+\-\d\.]+)\s*,?\s*([+\-\d\.]+)\s*,?\s*([+\-\d\.]+)\s*$/.exec(attr);
        if (arr && arr.length > 4) {
            return {
                sw: { lat: parseFloat(arr[3]), lng: parseFloat(arr[4]) },
                ne: { lat: parseFloat(arr[1]), lng: parseFloat(arr[2]) }
            };
        }
        return JSON.parse(attr);
    },
    convertBack: prop => JSON.stringify(prop)
};
export class MapUtils {
    static parseCoords(input) {
        if (input && !isNaN(input['lat']) && !isNaN(input['lng']))
            return [input['lat'], input['lng']];
        else if (Utils.isArray(input) && input.length > 1)
            return [input[0], input[1]];
        else if (/^\s*(\+|-)?[\d]+(.[\d]+)?\s*,\s*(\+|-)?[\d]+(.[\d]+)?\s*$/.test(input)) {
            var splitted = input.split(',');
            return [parseFloat(splitted[0]), parseFloat(splitted[1])];
        }
        return [MapConstsInternal.DEFAULT_COORDS.lat, MapConstsInternal.DEFAULT_COORDS.lng];
    }
    static expandBounds(bnds, latLng) {
        if (latLng) {
            if (!Array.isArray(latLng)) {
                latLng = [latLng.lat, latLng.lng];
            }
            bnds.push(latLng);
        }
    }
    static isContentEmpty(element) {
        return element.children.length == 0;
    }
}
;
export class MapRelevantElement extends PacemEventTarget {
    get map() {
        return this['_map'] = this['_map'] || CustomElementUtils.findAncestorOfType(this, PacemMapElement);
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first && name === 'hide') {
            const map = this.map;
            map?.adapter?.fitBounds(map, true);
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this.map && this.map.register(this);
    }
    disconnectedCallback() {
        this.map && this.map.unregister(this);
        super.disconnectedCallback();
    }
}
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], MapRelevantElement.prototype, "hide", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], MapRelevantElement.prototype, "inactive", void 0);
export class MapEvent extends CustomTypedEvent {
    constructor(type, args) {
        super(type, args);
    }
}
let PacemMapGeocodeElement = class PacemMapGeocodeElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this.debounce = 1000;
        this.#fetching = false;
    }
    #fetching;
    #handle;
    #promise;
    get fetching() {
        return this.#fetching;
    }
    _guards() {
        // if nothing changed return the current results
        const results = this.results;
        if (!Utils.isNullOrEmpty(results)) {
            const result = results[0];
            if (!Utils.isNull(this.position) && LatLng.equals(this.position, result.position) && this.search === result.fullAddress) {
                return Promise.resolve(results);
            }
        }
        // if adapter is not available then return an empty array
        const adapter = this.adapter;
        if (Utils.isNull(adapter) || adapter.disabled || !adapter.active) {
            return Promise.resolve([]);
        }
        // ok to fetch for new results
        return null;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'search':
                this.geocode(val);
                break;
            case 'position':
                this.reverseGeocode(val);
                break;
            case 'results':
                if (Utils.isNullOrEmpty(val)) {
                    this.search = '';
                    this.position = null;
                }
                else {
                    const r = val[0];
                    this.search = r.fullAddress;
                    this.position = r.position;
                }
                break;
        }
    }
    _broadcastFetchingUpdate(f) {
        if (f !== this.#fetching) {
            this.#fetching = f;
            this.dispatchEvent(new PropertyChangeEvent({ propertyName: 'fetching', oldValue: !f, currentValue: f }));
        }
    }
    _fetch(wrapper) {
        const { promise, search, position, key } = wrapper;
        const current = this.#promise;
        // check for equivalence
        if (!Utils.isNull(current)
            && LatLng.equals(current.position, position)
            && (current.search || '') === (search || '')) {
            return;
        }
        // update scope vars
        this.#promise = { key, promise, position, search };
        // green light
        this._broadcastFetchingUpdate(true);
        promise.then(r => {
            if (key === this.#promise.key) {
                this._broadcastFetchingUpdate(false);
                this._successCallback(r);
            }
        }, e => this._errorCallback(e));
    }
    _debounce(callback, debounce = this.debounce) {
        if (this.#handle) {
            clearTimeout(this.#handle);
        }
        this.#handle = window.setTimeout(() => {
            callback();
        }, debounce || 0);
    }
    reverseGeocode(position = this.position, maxResults = this.maxResults) {
        if (this.disabled) {
            return;
        }
        this._debounce(() => {
            const promise = this._guards() ?? this.adapter.reverseGeocode(position, maxResults || 1);
            this._fetch({ promise, position, key: Utils.uniqueCode() });
        });
    }
    geocode(search = this.search, maxResults = this.maxResults) {
        if (this.disabled) {
            return;
        }
        this._debounce(() => {
            const promise = this._guards() ?? this.adapter.geocode(search, maxResults || 10);
            this._fetch({ promise, search, position: LatLng.Empty, key: Utils.uniqueCode() });
        });
    }
    _successCallback(r) {
        const any = !Utils.isNullOrEmpty(r);
        if (any || !Utils.isNullOrEmpty(this.results)) {
            // change observable property if any result found
            // OR if an empty set should replace a non-empty one.
            if (r !== this.results) {
                this.results = r;
                if (any) {
                    // fire 'success' event only in case of non-empty set.
                    this.dispatchEvent(new CustomEvent('success', { detail: r, bubbles: false, cancelable: false }));
                }
            }
        }
    }
    _errorCallback(e) {
        if (!Utils.isNullOrEmpty(this.results)) {
            this.results = [];
        }
        this.dispatchEvent(new CustomEvent('error', { detail: e, bubbles: false, cancelable: false }));
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemMapGeocodeElement.prototype, "adapter", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemMapGeocodeElement.prototype, "maxResults", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemMapGeocodeElement.prototype, "debounce", void 0);
__decorate([
    Watch({ emit: true, converter: PropertyConverters.Json })
], PacemMapGeocodeElement.prototype, "results", void 0);
__decorate([
    Watch({ emit: true, converter: PropertyConverters.String })
], PacemMapGeocodeElement.prototype, "search", void 0);
__decorate([
    Watch({ emit: true, converter: LatLngConverter })
], PacemMapGeocodeElement.prototype, "position", void 0);
PacemMapGeocodeElement = __decorate([
    CustomElement({ tagName: MapConstsInternal.GEOCODER_SELECTOR })
], PacemMapGeocodeElement);
export { PacemMapGeocodeElement };
//#endregion
export class PacemMapAdapterElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this.active = true;
        this.#maps = new Map();
        this.#markers = new WeakMap();
        this.#shapes = new WeakMap();
        this.#layers = new WeakMap();
        this.#overlays = new WeakMap();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            this.active = !this.disabled && this.isActive();
        }
    }
    #maps;
    #markers;
    #shapes;
    #layers;
    #overlays;
    get layerAdapters() {
        return this.#layers;
    }
    get overlayAdapters() {
        return this.#overlays;
    }
    get markerAdapters() {
        return this.#markers;
    }
    get shapeAdapters() {
        return this.#shapes;
    }
    hasMap(map) {
        return this.#maps.has(map);
    }
    enrolledMaps() {
        return this.#maps.keys();
    }
    tryGetMap(map) {
        const maps = this.#maps;
        if (maps.has(map)) {
            return maps.get(map);
        }
        return null;
    }
    getMap(map) {
        const retval = this.tryGetMap(map);
        return retval?.map;
    }
    /**
     * Initializes the map and returns its corresponding DOM element.
     * @param map {PacemMapElement} Container for the map
     */
    async initialize(map) {
        const maps = this.#maps;
        if (!maps.has(map)) {
            const retval = await this.init(map);
            maps.set(map, retval);
            // initialize layer adapter
            const layers = this.#layers;
            if (!layers.has(map)) {
                layers.set(map, this.buildLayerAdapterFor(map));
            }
            // initialize overlay adapter
            const overlays = this.#overlays;
            if (!overlays.has(map)) {
                overlays.set(map, this.buildOverlayAdapterFor(map));
            }
            // initialize marker adapter
            const markers = this.#markers;
            if (!markers.has(map)) {
                markers.set(map, this.buildMarkerAdapterFor(map));
            }
            // initialize shape adapter
            const shapes = this.#shapes;
            if (!shapes.has(map)) {
                shapes.set(map, this.buildShapeAdapterFor(map));
            }
            return retval.container;
        }
        return maps.get(map).container;
    }
    /**
     * Disposes the resources attached to the map.
     * @param map {PacemMapElement} The map
     */
    destroy(map) {
        const layers = this.#layers;
        if (layers.has(map)) {
            layers.delete(map);
        }
        const overlays = this.#overlays;
        if (overlays.has(map)) {
            overlays.delete(map);
        }
        const markers = this.#markers;
        if (markers.has(map)) {
            markers.delete(map);
        }
        const shapes = this.#shapes;
        if (shapes.has(map)) {
            shapes.delete(map);
        }
        const maps = this.#maps;
        if (maps.has(map)) {
            this.dispose(map);
            maps.delete(map);
        }
    }
    /**
     * Removes a map element.
     * @param item {MapRelevantElement} item to be removed
     */
    removeItem(item) {
        const ctrl = item.map;
        // case layer
        if (item instanceof PacemMapLayerElement) {
            const layers = this.layerAdapters;
            if (layers.has(ctrl)) {
                const adapter = layers.get(ctrl);
                adapter.removeLayer(item);
            }
        }
        // case marker
        else if (item instanceof PacemMapMarkerElement) {
            const markers = this.markerAdapters;
            if (markers.has(ctrl)) {
                const adapter = markers.get(ctrl);
                adapter.removeMarker(item);
            }
        }
        // case shape
        else if (item instanceof PacemMapShapeElement) {
            const shape = this.shapeAdapters;
            if (shape.has(ctrl)) {
                const adapter = shape.get(ctrl);
                adapter.removeShape(item);
            }
        }
        // case overlay
        else if (item instanceof PacemMapOverlayElement) {
            const overlays = this.overlayAdapters;
            if (overlays.has(ctrl)) {
                const adapter = overlays.get(ctrl);
                adapter.removeOverlay(item);
            }
        }
        // TODO: other cases
        //...
        // fitBounds just in case
        if (!item.inactive) {
            this.fitBounds(ctrl, true);
        }
    }
    /**
     * Draws a map element.
     * @param item {MapRelevantElement} item to be drawn
     */
    drawItem(item) {
        const ctrl = item.map;
        // case layer
        if (item instanceof PacemMapLayerElement) {
            const layers = this.layerAdapters;
            if (layers.has(ctrl)) {
                const adapter = layers.get(ctrl);
                adapter.drawLayer(item);
            }
        }
        // case marker
        else if (item instanceof PacemMapMarkerElement) {
            const markers = this.markerAdapters;
            if (markers.has(ctrl)) {
                const adapter = markers.get(ctrl);
                adapter.drawMarker(item);
            }
        }
        // case shape
        else if (item instanceof PacemMapShapeElement) {
            const shapes = this.shapeAdapters;
            if (shapes.has(ctrl)) {
                const adapter = shapes.get(ctrl);
                adapter.drawShape(item);
            }
        }
        // case overlay
        else if (item instanceof PacemMapOverlayElement) {
            const overlays = this.overlayAdapters;
            if (overlays.has(ctrl)) {
                const adapter = overlays.get(ctrl);
                adapter.drawOverlay(item);
            }
        }
        // TODO: other cases
        //...
        // fitBounds just in case
        if (!item.inactive) {
            this.fitBounds(ctrl, true);
        }
    }
    /**
     * Shows the infowindow relevant to a map element (if any).
     * @param item {MapRelevantElement} item whose infowindow must be displayed
     */
    popupInfoWindow(item) {
        const ctrl = item.map;
        if (item instanceof PacemMapMarkerElement) {
            const markers = this.markerAdapters;
            if (markers.has(ctrl)) {
                markers.get(ctrl).openInfoWindow(item);
            }
        }
    }
    /**
     * Hides the infowindow relevant to a map element (if any).
     * @param item {MapRelevantElement} item whose infowindow must be hidden
     */
    popoutInfoWindow(item) {
        const ctrl = item.map;
        if (item instanceof PacemMapMarkerElement) {
            const markers = this.markerAdapters;
            if (markers.has(ctrl)) {
                markers.get(ctrl).closeInfoWindow(item);
            }
        }
    }
    setView(ctrl, center, zoom) {
        if (!this.hasMap(ctrl)) {
            return;
        }
        let options = {};
        if (typeof center === 'number') {
            options = Utils.extend({}, { zoom: center });
        }
        else if (LatLng.isLatLng(center)) {
            options = Utils.extend({}, { center, zoom });
        }
        else {
            options = center;
        }
        this.setViewNative(ctrl, options);
    }
    fitBounds(map, onlyIfAutofitOrBounds) {
        if (!Utils.isNull(map)) {
            this._fitBounds(map, onlyIfAutofitOrBounds);
        }
        else {
            for (let m of this.enrolledMaps() || []) {
                this._fitBounds(m, onlyIfAutofitOrBounds);
            }
        }
    }
    _fitBounds(ctrl, onlyIfAutofitOrBounds) {
        if (!this.hasMap(ctrl))
            return;
        // check against autofit
        if (!ctrl.autofit && onlyIfAutofitOrBounds === true)
            return;
        if (LatLngBounds.isLatLngBounds(onlyIfAutofitOrBounds) && !LatLngBounds.isEmpty(onlyIfAutofitOrBounds)) {
            this.fitBoundsNative(ctrl, onlyIfAutofitOrBounds);
            return;
        }
        const markersBounds = this.markerAdapters.get(ctrl)?.getBounds(), shapesBounds = this.shapeAdapters.get(ctrl)?.getBounds();
        // no markers nor shapes
        const emptyMarkerBounds = Utils.isNull(markersBounds) || LatLngBounds.isEmpty(markersBounds), emptyShapeBounds = Utils.isNull(shapesBounds) || LatLngBounds.isEmpty(shapesBounds);
        if (emptyMarkerBounds && emptyShapeBounds) {
            this.setView(ctrl, { center: ctrl.center, zoom: ctrl.zoom });
            return;
        }
        let bnds = LatLngBounds.Empty;
        if (!emptyMarkerBounds) {
            bnds = LatLngBounds.union(bnds, markersBounds);
        }
        if (!emptyShapeBounds) {
            bnds = LatLngBounds.union(bnds, shapesBounds);
        }
        if (!LatLngBounds.isPoint(bnds)) {
            this.fitBoundsNative(ctrl, bnds);
        }
        else {
            this.setView(ctrl, { zoom: ctrl.zoom, center: bnds.ne });
        }
    }
    ;
    updateMapElement(ctrl, arg1, arg2) {
        ['type', 'tilt', 'heading'].forEach(prop => {
            if (prop in arg1) {
                ctrl[prop] = arg1[prop];
            }
        });
        const zoom = ('zoom' in arg1) ? arg1.zoom : arg2;
        if (!Utils.isNullOrEmpty(zoom) && zoom !== ctrl.zoom) {
            ctrl.zoom = zoom;
        }
        const center = LatLng.isLatLng(arg1) ? arg1 : arg1.center;
        if (!Utils.isNullOrEmpty(center) && (center.lat != ctrl.center?.lat || center.lng != ctrl.center?.lng)) {
            ctrl.center = center;
        }
        // update bounds
        ctrl.updateBounds(this.getBounds(ctrl));
    }
}
__decorate([
    Watch({ emit: true, converter: PropertyConverters.Boolean })
], PacemMapAdapterElement.prototype, "active", void 0);
__decorate([
    Debounce(1000, (key, ctrl) => `pacem:debounce:${key}:${ctrl.id}`)
], PacemMapAdapterElement.prototype, "_fitBounds", null);
export class MapItemAdapter {
    constructor(_map, _adapter = _map.adapter) {
        this._map = _map;
        this._adapter = _adapter;
    }
    get adapter() { return this._adapter; }
    get map() { return this._map; }
    getMap(item) {
        return this._adapter.getMap(item.map);
    }
}
export class PacemOverlayAdapter extends MapItemAdapter {
    constructor(map, adapter = map.adapter) {
        super(map, adapter);
    }
    #overlays = new Map();
    get layers() { return this.#overlays; }
    onOverlayLoad(item, evt) {
        item.dispatchEvent(new Event('overlayload'));
    }
    ensureOverlay(item, map) {
        const ctrl = this, overlays = ctrl.#overlays;
        let overlay;
        if (!overlays.has(item)) {
            overlay = this.buildOverlay(item, map);
            if (!Utils.isNull(overlay)) {
                overlays.set(item, overlay);
            }
        }
        else {
            overlay = overlays.get(item);
        }
        return overlay;
    }
    removeOverlay(item) {
        const ctrl = this, map = ctrl.getMap(item), overlays = this.#overlays;
        if (overlays.has(item)) {
            const layer = overlays.get(item);
            ctrl.deleteOverlay(layer, map);
            overlays.delete(item);
        }
    }
    drawOverlay(item) {
        const ctrl = this, map = ctrl.getMap(item);
        if (Utils.isNull(map)) {
            return;
        }
        else if (Utils.isNullOrEmpty(item) || item.hide) {
            ctrl.removeOverlay(item);
            return;
        }
        //
        const overlay = this.ensureOverlay(item, map);
        this.setBounds(overlay, map, item.bounds);
        this.updateOverlay(overlay, map, item);
    }
}
export class PacemMapOverlayElement extends MapRelevantElement {
}
__decorate([
    Watch({ emit: false, converter: LatLngBoundsConverter })
], PacemMapOverlayElement.prototype, "bounds", void 0);
let PacemMapOverlayImageElement = class PacemMapOverlayImageElement extends PacemMapOverlayElement {
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemMapOverlayImageElement.prototype, "src", void 0);
PacemMapOverlayImageElement = __decorate([
    CustomElement({ tagName: MapConstsInternal.OVERLAY_IMAGE_SELECTOR })
], PacemMapOverlayImageElement);
export { PacemMapOverlayImageElement };
export class PacemLayerAdapter extends MapItemAdapter {
    constructor(map, adapter = map.adapter) {
        super(map, adapter);
    }
    #layers = new Map();
    #loadHandlers = new Map();
    get layers() { return this.#layers; }
    onTileLoad(item, evt) {
        item.dispatchEvent(new Event('tileload'));
    }
    ensureLayer(item, map) {
        const ctrl = this, layers = ctrl.#layers;
        let layer;
        if (!layers.has(item)) {
            layer = this.buildLayer(item, map);
            if (layer != null) {
                const handler = (e) => { ctrl.onTileLoad(item, e); };
                this.#loadHandlers.set(item, handler);
                this.addLoadEventListener(layer, map, handler);
                layers.set(item, layer);
            }
        }
        else {
            layer = layers.get(item);
        }
        return layer;
    }
    removeLayer(item) {
        const ctrl = this, map = ctrl.getMap(item), layers = this.#layers;
        if (layers.has(item)) {
            const layer = layers.get(item);
            const handlers = this.#loadHandlers;
            if (handlers.has(item)) {
                const handler = handlers.get(item);
                this.removeLoadEventListener(layer, map, handler);
                handlers.delete(item);
            }
            ctrl.deleteLayer(layer, map);
            layers.delete(item);
        }
    }
    drawLayer(item) {
        const ctrl = this, map = ctrl.getMap(item);
        if (Utils.isNull(map)) {
            return;
        }
        else if (Utils.isNullOrEmpty(item) || item.hide) {
            ctrl.removeLayer(item);
            return;
        }
        //
        this.ensureLayer(item, map);
    }
}
let PacemMapLayerElement = class PacemMapLayerElement extends MapRelevantElement {
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemMapLayerElement.prototype, "url", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemMapLayerElement.prototype, "include", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemMapLayerElement.prototype, "mode", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemMapLayerElement.prototype, "minZoom", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemMapLayerElement.prototype, "maxZoom", void 0);
PacemMapLayerElement = __decorate([
    CustomElement({ tagName: MapConstsInternal.LAYER_SELECTOR })
], PacemMapLayerElement);
export { PacemMapLayerElement };
export class PacemMarkerAdapter extends MapItemAdapter {
    constructor(map, adapter = map.adapter) {
        super(map, adapter);
    }
    get mapAutomaticallyScrollsOnDrag() {
        return false;
    }
    #markers = new Map();
    #infoWindows = new Map();
    getBounds(filter = _ => true) {
        const markers = this.markers;
        let bnds = LatLngBounds.Empty;
        for (var m of markers.keys()) {
            if (!filter(m) || m.inactive) {
                continue;
            }
            let marker = markers.get(m);
            if (Utils.isNull(marker)) {
                continue;
            }
            bnds = LatLngBounds.union(bnds, this.getMarkerPosition(marker));
        }
        return bnds;
    }
    get markers() { return this.#markers; }
    get infoWindows() { return this.#infoWindows; }
    onDragEnd(item, evt) {
        const marker = this.markers.get(item), dpos = this.getMarkerPosition(marker);
        item.onDragEnd(dpos);
    }
    onClick(item, evt) {
        const marker = this.markers.get(item), dpos = this.getMarkerPosition(marker);
        item.onClick(dpos);
    }
    onInfoOpen(item) {
        item.onInfoOpen();
    }
    onInfoClose(item) {
        item.onInfoClose();
    }
    ensureMarker(item, map) {
        const ctrl = this;
        let marker;
        if (!ctrl.markers.has(item)) {
            marker = this.buildMarker(item, map);
            if (marker != null) {
                this.addClickEventListener(marker, map, (e) => { ctrl.onClick(item, e); ctrl.openInfoWindow(item, e); });
                this.addDragEventListener(marker, map, (e) => { if (!this.mapAutomaticallyScrollsOnDrag)
                    ctrl.adapter.fitBounds(item.map, true); });
                this.addDragEndEventListener(marker, map, (e) => ctrl.onDragEnd(item, e));
                ctrl.markers.set(item, marker);
            }
        }
        else {
            marker = ctrl.markers.get(item);
        }
        return marker;
    }
    removeMarker(item) {
        const ctrl = this, map = ctrl.getMap(item), infoWindows = this.#infoWindows, markers = this.#markers;
        if (infoWindows.has(item)) {
            // const info = infoWindows.get(item);
            infoWindows.delete(item);
        }
        if (markers.has(item)) {
            const marker = markers.get(item);
            ctrl.deleteMarker(marker, map);
            markers.delete(item);
            // ctrl._adapter.removeItem(item);
        }
    }
    drawMarker(item) {
        const ctrl = this, map = ctrl.getMap(item);
        if (Utils.isNull(map)) {
            return;
        }
        else if (Utils.isNullOrEmpty(item && item.position) || item.hide) {
            ctrl.removeMarker(item);
            return;
        }
        //
        const marker = this.ensureMarker(item, map);
        // set position
        this.setPosition(marker, item.position);
        this.setIcon(marker, item.icon);
        this.setLabel(marker, item.caption);
        this.setDraggable(marker, item.draggable);
    }
    closeInfoWindow(item, evt) {
        const ctrl = this;
        if (ctrl.infoWindows.has(item)) {
            const info = ctrl.infoWindows.get(item);
            this.closeInfo(info);
        }
    }
    ensureInfoWindow(item, map) {
        var ctrl = this;
        let info;
        if (!ctrl.infoWindows.has(item)) {
            info = this.buildInfoWindow(item);
            this.addCloseClickEventListener(info, map, (_) => {
                ctrl.deleteInfoWindow(info, map);
                ctrl.onInfoClose(item);
            });
            ctrl.infoWindows.set(item, info);
        }
        else {
            info = ctrl.infoWindows.get(item);
        }
        return info;
    }
    openInfoWindow(item, evt) {
        var ctrl = this, marker = ctrl.markers.get(item), content = item.caption, map = ctrl.getMap(item);
        if (!MapUtils.isContentEmpty(item)) {
            content = item.innerHTML;
        }
        if (!Utils.isNullOrEmpty(content)) {
            const info = this.ensureInfoWindow(item, map);
            this.setContent(info, content);
            this.openInfo(info, content, map, marker);
            ctrl.onInfoOpen(item);
        }
    }
}
let PacemMapMarkerElement = class PacemMapMarkerElement extends MapRelevantElement {
    onDragEnd(position) {
        this.position = position;
        this.dispatchEvent(new MapEvent('dragend', { position: position }));
    }
    onClick(position) {
        this.position = position;
        this.dispatchEvent(new MapEvent('click', { position: position }));
    }
    onInfoOpen() {
        this.dispatchEvent(new MapEvent('openinfo'));
    }
    onInfoClose() {
        this.dispatchEvent(new MapEvent('closeinfo'));
    }
};
__decorate([
    Watch({ converter: LatLngConverter })
], PacemMapMarkerElement.prototype, "position", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Json })
], PacemMapMarkerElement.prototype, "icon", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemMapMarkerElement.prototype, "caption", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemMapMarkerElement.prototype, "draggable", void 0);
PacemMapMarkerElement = __decorate([
    CustomElement({ tagName: MapConstsInternal.MARKER_SELECTOR })
], PacemMapMarkerElement);
export { PacemMapMarkerElement };
export class PacemShapeAdapter extends MapItemAdapter {
    constructor(map, adapter = map.adapter) {
        super(map, adapter);
    }
    #shapes = new Map();
    get shapes() { return this.#shapes; }
    getBounds(filter = _ => true) {
        const shapes = this.shapes;
        let bnds = LatLngBounds.Empty;
        for (var s of shapes.keys()) {
            if (!filter(s) || s.inactive) {
                continue;
            }
            let shape = shapes.get(s);
            if (Utils.isNull(shape)) {
                continue;
            }
            bnds = LatLngBounds.union(bnds, this.getShapeBounds(shape));
        }
        return bnds;
    }
    removeShape(item) {
        const ctrl = this, map = ctrl.getMap(item), shapes = this.#shapes;
        if (shapes.has(item)) {
            const shape = shapes.get(item);
            ctrl.deleteShape(shape, map);
            shapes.delete(item);
        }
    }
    _dispatchEvent(item, type, evt) {
        const shape = this.shapes.get(item), position = this.getShapePosition(evt ?? shape);
        item.dispatchEvent(new MapEvent(type, { position }));
    }
    #dragDelta = new Map();
    onDragStart(item, evt) {
        const shape = this.shapes.get(item);
        const bounds = this.getShapeBounds(shape);
        this.#dragDelta.set(item, bounds.ne);
        this._dispatchEvent(item, 'dragstart', evt);
    }
    onDragEnd(item, evt) {
        const shape = this.shapes.get(item);
        const bounds = this.getShapeBounds(shape);
        const neStart = this.#dragDelta.get(item), neEnd = bounds.ne;
        ;
        const delta = { lat: neEnd.lat - neStart.lat, lng: neEnd.lng - neStart.lng };
        this._translateShape(item, delta);
        this._dispatchEvent(item, 'dragend', evt);
    }
    _translateShape(item, latLng) {
        if (item instanceof PacemMapCircleElement) {
            item.center = LatLng.translate(item.center, latLng);
            return;
        }
        if (item instanceof PacemMapPolylineElement) {
            const path = item.vertices.map(p => LatLng.translate(p, latLng));
            item.vertices = path;
            return;
        }
        if (item instanceof PacemMapPolygonElement) {
            const path = item.vertices.map(p => LatLng.translate(p, latLng));
            item.vertices = path;
            return;
        }
    }
    onDrag(item, evt) {
        this._dispatchEvent(item, 'drag', evt);
    }
    onClick(item, evt) {
        this._dispatchEvent(item, 'click', evt);
    }
    ensureShape(item, map) {
        const ctrl = this;
        let shape;
        if (!ctrl.shapes.has(item)) {
            shape = this.buildShape(item, map);
            if (shape != null) {
                this.addClickEventListener(shape, (e) => ctrl.onClick(item, e));
                this.addDragEventListener(shape, (e) => { ctrl.onDrag(item, e); ctrl.adapter.fitBounds(item.map, true); });
                this.addDragEndEventListener(shape, (e) => ctrl.onDragEnd(item, e));
                this.addDragStartEventListener(shape, (e) => ctrl.onDragStart(item, e));
                ctrl.shapes.set(item, shape);
            }
        }
        else {
            shape = ctrl.shapes.get(item);
        }
        return shape;
    }
    drawShape(item) {
        const ctrl = this, map = ctrl.getMap(item);
        if (Utils.isNull(map)) {
            return;
        }
        else if (Utils.isNullOrEmpty(item) || item.hide) {
            ctrl.removeShape(item);
            return;
        }
        //
        const shape = this.ensureShape(item, map);
        this.setShape(shape, item);
        this.setEditable(shape, item.editable);
        this.setDraggable(shape, item.draggable);
    }
}
export class PacemMapShapeElement extends MapRelevantElement {
}
__decorate([
    Watch({ emit: true, converter: PropertyConverters.Boolean })
], PacemMapShapeElement.prototype, "draggable", void 0);
__decorate([
    Watch({ emit: true, converter: PropertyConverters.Boolean })
], PacemMapShapeElement.prototype, "editable", void 0);
__decorate([
    Watch({ emit: true, converter: PropertyConverters.Json })
], PacemMapShapeElement.prototype, "stroke", void 0);
__decorate([
    Watch({ emit: true, converter: PropertyConverters.Json })
], PacemMapShapeElement.prototype, "fill", void 0);
let PacemMapPolylineElement = class PacemMapPolylineElement extends PacemMapShapeElement {
};
__decorate([
    Watch({ emit: true, converter: PropertyConverters.Json })
], PacemMapPolylineElement.prototype, "vertices", void 0);
PacemMapPolylineElement = __decorate([
    CustomElement({ tagName: MapConstsInternal.POLYLINE_SELECTOR })
], PacemMapPolylineElement);
export { PacemMapPolylineElement };
let PacemMapPolygonElement = class PacemMapPolygonElement extends PacemMapShapeElement {
};
__decorate([
    Watch({ emit: true, converter: PropertyConverters.Json })
], PacemMapPolygonElement.prototype, "vertices", void 0);
PacemMapPolygonElement = __decorate([
    CustomElement({ tagName: MapConstsInternal.POLYGON_SELECTOR })
], PacemMapPolygonElement);
export { PacemMapPolygonElement };
let PacemMapCircleElement = class PacemMapCircleElement extends PacemMapShapeElement {
};
__decorate([
    Watch({ emit: true, converter: LatLngConverter })
], PacemMapCircleElement.prototype, "center", void 0);
__decorate([
    Watch({ emit: true, converter: PropertyConverters.Json })
], PacemMapCircleElement.prototype, "radius", void 0);
PacemMapCircleElement = __decorate([
    CustomElement({ tagName: MapConstsInternal.CIRCLE_SELECTOR })
], PacemMapCircleElement);
export { PacemMapCircleElement };
//#endregion
let PacemMapElement = class PacemMapElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this.zoom = 12;
        this.center = MapConstsInternal.DEFAULT_COORDS;
        this.#bounds = LatLngBounds.Empty;
        this.scale = true;
        this.mousewheel = true;
        this.draggable = true;
        this.doubleClickZoom = true;
        this.keyboardShortcuts = true;
        /** Gets or sets whether to autofit the bounds whenever the map gets refreshed. */
        this.autofit = true;
        this.paddingTop = 0;
        this.paddingLeft = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
        // GMaps features
        this.tilt = 0;
        this.heading = 0;
        this._drawHandler = (evt) => {
            this._draw(evt.target);
        };
        //#endregion
        //#region lifecycle
        this._listenToActiveAdapter = (e) => {
            const adapter = e.target;
            if (e.detail.propertyName === 'active' && e.detail.currentValue) {
                adapter.removeEventListener(PropertyChangeEventName, this._listenToActiveAdapter, false);
                this._switchAdapter(adapter);
            }
        };
        this._initialized = false;
        this._afterInit = (_, old) => {
            this._initialized = true;
            // loop through child element map-relevant-items
            for (var child of CustomElementUtils.findDescendants(this, n => n instanceof MapRelevantElement)) {
                this._erase(child, old);
                this._draw(child);
            }
            // dispose old, if any.
            if (old) {
                old?.destroy(this);
            }
        };
        this._resizeHandler = (e) => {
            this.onResize(e);
        };
        //#endregion
    }
    updateBounds(bounds) {
        if (!LatLngBounds.equals(bounds, this.#bounds)) {
            const oldValue = this.#bounds;
            const currentValue = this.#bounds = bounds;
            this.dispatchEvent(new PropertyChangeEvent({ propertyName: 'bounds', oldValue, currentValue }));
        }
    }
    #bounds;
    get bounds() {
        return this.#bounds;
    }
    get container() {
        return this._container;
    }
    register(item) {
        item.addEventListener(PropertyChangeEventName, this._drawHandler, false);
        this._draw(item);
    }
    unregister(item) {
        this._erase(item);
        item.removeEventListener(PropertyChangeEventName, this._drawHandler, false);
    }
    _draw(item, adapter = this.adapter) {
        this._initialized &&
            adapter &&
            adapter.drawItem(item);
    }
    _erase(item, adapter = this.adapter) {
        this._initialized &&
            adapter &&
            adapter.removeItem(item);
    }
    _switchAdapter(val, old) {
        if (!val.active) {
            if (old) {
                this._afterInit(null, old);
            }
            val.addEventListener(PropertyChangeEventName, this._listenToActiveAdapter, false);
        }
        else {
            val.initialize(this).then(_ => this._afterInit(_, old));
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._setupContainer();
        //
        this.adapter && this._switchAdapter(this.adapter);
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'bounds') {
            return;
        }
        if (name === 'adapter') {
            if (!Utils.isNull(this._container)) {
                this._initialized = false;
                if (val) {
                    this._switchAdapter(val, old);
                }
                else if (old) {
                    this._afterInit(null, old);
                }
            }
        }
        else {
            switch (name) {
                case 'zoom':
                case 'center':
                case 'type':
                case 'theme':
                case 'tilt':
                case 'heading':
                    this.adapter?.setView(this, { type: this.type, tilt: this.tilt, heading: this.heading, zoom: this.zoom, center: this.center, theme: this.theme });
                    break;
                case 'autofit':
                    if (val) {
                        this.adapter?.fitBounds(this);
                    }
                    break;
                case 'target':
                    if (old) {
                        this._dismissContainer(old);
                    }
                    if (val) {
                        this._setupContainer(val);
                        this._setupResizer();
                    }
                    else {
                        this._dismissResizer();
                    }
                    break;
            }
            this.adapter && this.adapter.invalidateSize(this);
        }
    }
    _dismissContainer(container = this._container) {
        if (container.dataset[DEFAULT_MAPTARGET_KEY] === 'true') {
            container.remove();
        }
        else {
            Utils.removeClass(container, PCSS + '-map');
        }
        if (container === this._container) {
            this._container = null;
        }
    }
    _dismissResizer() {
        const resizer = this._resizer;
        resizer.removeEventListener('resize', this._resizeHandler, false);
        resizer.remove();
        this._resizer = null;
    }
    _setupContainer(val = this.target) {
        if (Utils.isNull(val)) {
            val = document.createElement('div');
            val.dataset[DEFAULT_MAPTARGET_KEY] = 'true';
            this.insertAdjacentElement('afterend', val);
        }
        const container = this._container = val;
        Utils.addClass(container, PCSS + '-map');
        return container;
    }
    _setupResizer() {
        const container = this._container;
        if (Utils.isNull(container)) {
            throw new Error('You must set up the map container before its resizing listener.');
        }
        if (Utils.isNull(this._resizer)) {
            const resizer = this._resizer = document.createElement(P + '-resize');
            resizer.addEventListener('resize', this._resizeHandler, false);
            container.insertAdjacentElement('afterend', resizer);
        }
        this._resizer.target = container;
        return this._resizer;
    }
    _detach() {
        if (!Utils.isNull(this._container)) {
            this._dismissContainer();
        }
        if (!Utils.isNull(this._resizer)) {
            this._dismissResizer();
        }
    }
    disconnectedCallback() {
        this._detach();
        super.disconnectedCallback();
    }
    onResize(e) {
        this.adapter && this.adapter.invalidateSize(this);
    }
};
__decorate([
    Watch({ emit: true, converter: PropertyConverters.Number })
], PacemMapElement.prototype, "zoom", void 0);
__decorate([
    Watch({ emit: true, converter: LatLngConverter })
], PacemMapElement.prototype, "center", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemMapElement.prototype, "type", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemMapElement.prototype, "theme", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemMapElement.prototype, "scale", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemMapElement.prototype, "mousewheel", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemMapElement.prototype, "zoomControl", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemMapElement.prototype, "draggable", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemMapElement.prototype, "doubleClickZoom", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemMapElement.prototype, "keyboardShortcuts", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemMapElement.prototype, "autofit", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemMapElement.prototype, "paddingTop", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemMapElement.prototype, "paddingLeft", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemMapElement.prototype, "paddingRight", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemMapElement.prototype, "paddingBottom", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemMapElement.prototype, "adapter", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemMapElement.prototype, "target", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemMapElement.prototype, "tilt", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemMapElement.prototype, "heading", void 0);
PacemMapElement = __decorate([
    CustomElement({ tagName: MapConstsInternal.MAP_SELECTOR })
], PacemMapElement);
export { PacemMapElement };
//}
